export const DATADOG_APPLICATION_ID = 'b3be2299-5e24-4674-839b-3fd8ec0416f4';
export const DATADOG_CLIENT_TOKEN = 'pub751b07243a6a8d19e8cb9e33b6155cf9';
